import React, { forwardRef, useEffect, useState } from 'react';

import { Datepicker } from '@mobiscroll/react';
import moment from 'moment/moment';

import { TimePickerStyled } from './TimePicker.style';
import { renderTimePickerVariant } from './TimePickerInputVariant';

import type { Moment } from 'moment';

type DatePickerProps = {
  id?: string;
  variant?: 'iconButton' | 'input' | 'button';
  isDisabled?: boolean;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isFullWidth?: boolean;
  isError?: boolean;
  label?: string;
  placeholder?: string;
  value?: string;
  helperText?: string;
  errorMessage?: string;
  size?: 'small' | 'medium';
  dateFormat?: string;
  onChange: (date: Moment | null) => void;
  isClearable?: boolean;
  classNameForTargetUserOnboardingTooltip?: string;
  [x: string]: any;
};

export const TimePicker = forwardRef<HTMLHeadingElement, DatePickerProps>((props, ref) => {
  const [isShowPopup, setIsShowPopup] = useState(false);
  const [now, setNow] = useState<any>();

  const {
    id,
    isDisabled,
    isError,
    isFullWidth = true,
    isRequired,
    isReadOnly = false,
    errorMessage,
    label,
    placeholder,
    isClearable,
    helperText,
    value,
    size,
    dateFormat,
    variant = 'input',
    classNameForTargetUserOnboardingTooltip,
    onChange,
    ...args
  } = props;
  const onOpenPopup = () => {
    setIsShowPopup(true);
  };
  const onClosePopup = () => {
    setIsShowPopup(false);
  };

  const handleChange = (val: any) => {
    onChange(val.value);
  };

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if ((event.target as HTMLElement).classList.contains('mbsc-scroller-wheel-item')) {
        now?.close?.();
      }
    };
    if (isShowPopup) {
      document.addEventListener('click', handleClick);
    }

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [now, isShowPopup]);

  return (
    <TimePickerStyled id={id || 'timePicker'}>
      <Datepicker
        {...args}
        inputRef={ref}
        ref={setNow}
        themeVariant="light"
        moment={moment}
        cssClass="time-picker"
        onChange={handleChange}
        onOpen={onOpenPopup}
        onClose={onClosePopup}
        defaultValue={value}
        focusOnClose={false}
        disabled={isDisabled}
        controls={['time']}
        value={value}
        theme="ios"
        returnFormat="moment"
        stepMinute={15}
        timeWheels={'|h:mm A|'}
        dateFormat={dateFormat || 'h:mm A'}
        touchUi={false}
        inputComponent={renderTimePickerVariant}
        inputProps={{
          isClearable,
          label,
          errorMessage,
          isFullWidth,
          isDisabled,
          isReadOnly,
          isRequired,
          onChange,
          isError,
          variant,
          placeholder,
          helperText,
          size,
          value,
          isShowPopup,
          dateFormat,
        }}
      />
      <div className={classNameForTargetUserOnboardingTooltip} />
    </TimePickerStyled>
  );
});
